(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('purchaseRequisitionsHistory', purchaseRequisitionsHistory);

	purchaseRequisitionsHistory.$inject = ['$scope',  '$timeout', '$rootScope', '$state', '$location', 'redirectParamsService',
		'leanFilterService', 'tableRenderService', 'tableService', 'pageTimingService', 'columnsService', 'storeService'];

	function purchaseRequisitionsHistory($scope, $timeout, $rootScope, $state, $location, redirectParamsService,
			leanFilterService, tableRenderService, tableService, pageTimingService, columnsService, storeService) {
		var vm = this;
		var unsubscribe;

		var rendererParams = {
			'itemDescription': 'description',
			'multiFactory': true,
			'specificTaskType': 'task'
		};
		var reportSettingsName = 'purchase-requisitions-history';
		var pinnedColumns = [];
		var defaultFilters = [];

		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;
		var isSupplier = globalConfig.user.role === 'Supplier';

		// Set navigation properties
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});
		$scope.$on('$destroy', function() {
			userTimingListener();
		});

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming('Purchase Requisition History');
				timingCalled = true;
			}
		}

		var extraFilters = [{
			'name': 'daysUntilPOFirm',
			'type': 'range',
			'comparator': 'Less Than Or Equal To',
			'valueOne': 'maxDaysUntilPOFirm'
		}];

		$scope.filterService = leanFilterService;
		vm.reportName = 'Purchase requisition history';
		vm.showExcel = true;

		var columns = columnsService({
			prHistoryDate: 0,
			supplyOrderNumber: 'PR Number',
			orderLine: 'PR Line',
			scheduleLine: 1,
			orderCreationDate: 'PR Creation Date',
			requestedDate: 'Expected Delivery Date',
			promiseDate: 'Supplier Commit Date',
			leadTimeInDaysFloat: 1,
			insideLeadTime: 1,
			factoryAlias: 1,
			businessUnit: 0,
			division: 0,
			entity: 0,
			itemCode: 1,
			itemType: 0,
			itemGroupName: 0,
			supplierName: 1,
			supplierCode: 0,
			buyerCode: 1,
			externalMaterialGroup: 0,
			materialGroup: 1,
			materialType: 0
		});

		var columnsForRequest = _.cloneDeep(columns);

		init();
		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			reportName: vm.reportName,
			reportUrl: '{0}/PurchaseRequisitionHistoryReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'orderCreationDate',
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			extraParams: [{}],
			rendererParams: rendererParams,
			pageSize: 50,
			extraFilters: extraFilters,
			setColumnDefaults: true,
			excelRequest: true,
			useReportBuilderForExcel: true,
			excelReportName: 'Purchase Requisitions History',
			hasMandatoryFilters: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = meta.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = meta.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		var excelColumns = [
			'supplierCode',
			'buyerCode'
		].map(function(id) { return { id: id }; });
		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', { columns: columnsForRequest.concat(excelColumns), doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined });
		}

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, columnsForRequest).then(function (response) {
				return response;
			});
		}

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			defaultFilters = [{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true },
				{ 'id': 'buyerCode', 'values': [$scope.filterService.leanDnaAllSelected] }];
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;
			var masterFilterList = [
				leanFilterService.filterDefinitions['BusinessUnit'],
				leanFilterService.filterDefinitions['Division'],
				leanFilterService.filterDefinitions['Entity'],
				siteFilter,
				$scope.filterService.filterDefinitions['Item Group'],
				$scope.filterService.filterDefinitions['ItemType'],
				$scope.filterService.filterDefinitions['Buyer'],
				$scope.filterService.filterDefinitions['Supplier'],
				$scope.filterService.filterDefinitions['MaterialGroup'],
				$scope.filterService.filterDefinitions['MaterialType'],
				$scope.filterService.filterDefinitions['PRInsideLeadTime']
			];
			if (isSupplier) {
				defaultFilters = [
					{ id: 'factory', values: [globalConfig.factory.id], 'isMandatory': true }
				];
			}
			var rangeFilters = [
				_.assign({}, $scope.filterService.filterDefinitions['DeliveryDate'], { id: 'requestedDate' }),
				_.assign({}, $scope.filterService.filterDefinitions['OrderCreationDate'], { displayName: 'PR Creation Date', showNotBtw: true }),
				$scope.filterService.filterDefinitions['PrHistoryDate']
			];
			$scope.filterService.setMasterFilterList(masterFilterList);
			$scope.filterService.setMasterRangeFilterList(rangeFilters);
			$scope.filterService.setMasterStringFilterList([
				_.assign({}, $scope.filterService.filterDefinitions['SupplyOrderNumber'], {displayName:'PR Number'})
			]);
		}
	}
})();
